module.exports = __webpack_public_path__ + "right-download-ios-bfae97d1.png";